import type { FormikContextType } from 'formik';
import { useFormik } from 'formik';
import _ from 'lodash';
import { useRef } from 'react';
import * as Yup from 'yup';
import type { Installer } from '../../../model';
import { useUpsertInstaller } from '../graphql';
// import { Alert } from '../../../../store';

export interface Props {
  installer?: Installer;
  onClose: () => void;
}

interface Values {
  id?: string;
  url: string;
  notes: string;
  name: string;
  expirationTime: number;
  software: string;
}

interface Form {
  formik: FormikContextType<Values>;
  loading: boolean;
//   alert: Alert;
}

// validate if checkbox is selected and require dropdown/select
const validationSchema = Yup.object({
  software: Yup.string().required('Required field'),
  name: Yup.string().required('Required field'),
  url: Yup.string().required('Required field'),
  notes: Yup.string(),
  expirationTime: Yup.number().required('Required field').min(1, 'Required field')
});

export const useForm = ({ installer, onClose }: Props): Form => {
  const [mutation, { loading }] = useUpsertInstaller();
  //   const alert = Alert.useAlert(error);

  const initialValues = useRef({
    id: installer?.id,
    software: installer?.software ?? '',
    name: installer?.versionName ?? '',
    url: installer?.url ?? '',
    notes: installer?.notes ?? '',
    expirationTime: !Number.isNaN(Number(installer?.expirationTime)) ? Number(installer?.expirationTime) : 0
  }).current;

  const formik = useFormik<Values>({
    initialValues,
    validationSchema,
    validateOnMount: true,

    /*
     * validate(): void {
     *   alert.hide();
     * },
     */

    async onSubmit(values: Values): Promise<void> {
      // alert.hide();

      if (await mutation(values)) {
        onClose();
      }
    }
  });

  return {
    formik,
    loading
    // alert
  };
};
